import { Playlist, VideoEvent } from '@statsbomb/video-client-js';
import { useTrackVideoStart } from '@/analytics/snowplow/hooks/useTrackVideoStart';
import { UnavailableVideosMessage } from '@/components/video/UnavailableVideosMessage';
import { VideoAuthAndKeyboardWrapper } from '@/components/VideoProvider';
import { defaultVideoControls } from '@/consts/video';
import { useFormatVideoEvents } from '@/hooks/useFormatVideoEvents';
import { EventDescription } from '@/types/event';
import { Nullable } from '@/types/generic';
import { SelectedVideoIds } from '@/types/video';
import { WideFirstColumnLayout } from '../WideFirstColumnLayout';

export const GameStatsVideoLayout = ({
  videoEventIds,
  descriptionsData,
  unavailableVideosCount,
}: {
  videoEventIds: Nullable<SelectedVideoIds[]>;
  descriptionsData: EventDescription[];
  unavailableVideosCount?: number;
}) => {
  useTrackVideoStart();
  const videoEvents = useFormatVideoEvents(videoEventIds, descriptionsData);

  return (
    <div className="h-full video-column-order [&>div]:h-full [&_[data-column='1']>div]:pt-0">
      <VideoAuthAndKeyboardWrapper>
        <WideFirstColumnLayout>
          <>
            <UnavailableVideosMessage unavailableVideosCount={unavailableVideosCount} />
            {videoEvents.length > 0 && (
              <span data-testid="game-stats-video-playlist">
                <Playlist enableEditMode />
              </span>
            )}
          </>
          <VideoEvent autoPlay events={videoEvents} controls={defaultVideoControls} />
        </WideFirstColumnLayout>
      </VideoAuthAndKeyboardWrapper>
    </div>
  );
};
